import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Viksit Bharat @2047</h1>
                <h4>Empowering youth to shape a developed, self-reliant, and prosperous India by its 100th year of independence.</h4>
                <p>Home &gt; Viksit Bharat</p>
            </div>
        </div>
    )
}

export default Hero;